import { render, staticRenderFns } from "./WebhookRules.vue?vue&type=template&id=25d61a70&scoped=true"
import script from "./WebhookRules.vue?vue&type=script&lang=js"
export * from "./WebhookRules.vue?vue&type=script&lang=js"
import style0 from "./WebhookRules.vue?vue&type=style&index=0&id=25d61a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d61a70",
  null
  
)

export default component.exports